import React from 'react';

export default language => {
    let path = 0;
    let pathArray = [];

    switch(language) {
        case 'pl':
        case 'fi':
            path = 2;
        break;
        case 'sl':
            path = 4;
        break;
        case 'sv':
        case 'pt':
        case 'da':
            path = 5;
        break;
        case 'zh':
        case 'no':
        case 'el':
            path = 6;
        break;
        case 'sk':
            path = 7;
        break;
        case 'en':
            path = 14;
        break;
        case 'hr':
            path = 22;
        break;
        default:
            path = 3;
        break;
    }

    for (let i = 0; i < path; i++) {
        pathArray.push(i + 1);
    }

    return (
        <i className={`icon-${language}`}>
            {
                pathArray.map(value => {
                    return (
                        <i key={`${language}-path-${value}`} className={`path${value}`}></i>
                    )
                })
            }
        </i>
    )

}